import React from "react";
import { FileText, Upload } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import { downloadInvoiceTemplate, downloadSkippedCsv } from "./invoiceActions";

const btn = "h-10 px-4 rounded-md border text-sm font-medium flex items-center gap-2 transition-colors";

export const InvoiceUploadBar = ({ skippedReport, setSkippedReport, onImported }) => {
  const importInvoices = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/invoices/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`${data.created} invoice${data.created === 1 ? "" : "s"} imported`);
      if (data.skipped?.length) {
        setSkippedReport(data);
        toast.error(`${data.skipped.length} row(s) skipped: ${data.errors[0]}`, {
          duration: 15000, action: { label: "Download list", onClick: () => downloadSkippedCsv(data) },
        });
      } else setSkippedReport(null);
      onImported();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button data-testid="invoice-template-btn" onClick={downloadInvoiceTemplate} className={`${btn} border-input bg-card hover:bg-muted`}>
        <FileText size={15} /> Template
      </button>
      <label data-testid="bulk-invoice-upload" className={`${btn} border-input bg-card cursor-pointer hover:bg-muted`}>
        <Upload size={15} /> Bulk upload (CSV / Excel)
        <input data-testid="inv-bulk-input" type="file" accept=".csv,.xlsx" className="hidden" onChange={importInvoices} />
      </label>
      {skippedReport?.skipped?.length > 0 && (
        <button data-testid="inv-skipped-download" onClick={() => downloadSkippedCsv(skippedReport)} className={`${btn} border-destructive/40 text-destructive hover:bg-destructive/10`}>
          <FileText size={15} /> {skippedReport.skipped.length} skipped rows
        </button>
      )}
    </div>
  );
};

export const InvoiceUploadHelp = () => (
  <p className="text-xs text-muted-foreground -mt-3 mb-4">Bulk upload is for <b>Tata Motors</b> invoices only (GST e-invoices). Download the Template, fill rows, then upload. Columns: date, invoice_number, <b className="text-destructive">job_card_number (mandatory — job card / order no.)</b>, challan_number, <b className="text-destructive">account_name (mandatory on every row)</b>, driver_mobile, amount, invoice_type, settlement (cash/bank/credit/partial), payment_mode (cash/upi/bank/qr), reference, vehicle_number, description. Dates may be YYYY-MM-DD or DD-MM-YYYY. <b className="text-destructive">For credit / partial rows, account_name must be an existing credit account and driver_mobile (10 digits) is mandatory.</b> Paid rows can use any account / customer name. There is no party_name column any more (old files with it still upload; it is ignored from 28-10-2026). If settlement is left blank, the row is treated as <b>cash (paid)</b>. Outside invoices are added one by one from the Cash Book. Unpaid invoices appear under <b>Pending Payments</b>, where a receipt is generated when you record the payment.</p>
);
